import React, { useEffect, useRef, useState } from 'react';
import { Conversations, Messages } from '@/Components';
import { NODE_SERVER_URL } from '@/constants';
import { io } from 'socket.io-client';
import { useParams } from 'react-router-dom';
import { chatServerInstance } from '@/helpers';

export const AirmailChat = () => {
    const [selectedChat, setSelectedChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [socket, setSocket] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const drawerRef = useRef(null);
    const { booking_id } = useParams();

    useEffect(() => {
        // Initialize the socket connection when the provider mounts
        const newSocket = io(NODE_SERVER_URL);

        // Set the socket instance in state
        setSocket(newSocket);

        // Listen for the 'connect' event to check when socket is connected
        newSocket.on('connect', () => {
            console.log('Socket connected:', newSocket.id);
            setLoading(false); // Set loading to false when socket is connected
        });

        // Cleanup on unmount
        return () => {
            newSocket.disconnect();
        };
    }, []);

    useEffect(() => {
        if (booking_id) {
            fetchChatAndMessages(booking_id);
        }
    }, [booking_id]);

    const fetchChatAndMessages = async (booking_id) => {
        try {
            const response = await chatServerInstance.get(`/getChatByBookingId/${booking_id}`);
            console.log(response?.data)
            setSelectedChat(response.data.chat);

        } catch (error) {
            console.error('Error fetching chat and messages:', error);
        }
    };

    // Close drawer when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                setIsDrawerOpen(false);
            }
        };

        if (isDrawerOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isDrawerOpen]);

    // If socket is still loading, show loading message or spinner
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-5">
                <img
                    className="h-auto w-36 md:w-44" // Responsive sizes
                    src="/image/fly-inn-logo.svg"
                    alt="Fly Inn Logo"
                />
                <div className="text-2xl text-bold">Please Wait while we load your data!</div>
            </div>
        );
    }

    return (
        <div className="fixed top-[7.7rem] w-webkit h-[87%] flex w-lg-[100vw]">

            {/* Open Chat Button for Small Screens */}
            <button
                onClick={() => setIsDrawerOpen(true)}
                className="lg:hidden absolute top-[50%] left-4 z-10 bg-gray-800 text-white p-3 rounded-full"
            >
                <i className="text-2xl fas fa-comments" />
            </button>
            {/* hide this on md devices */}
            <div className="hidden w-1/3 bg-white border-r border-gray-300 lg:block">
                <h3 className='p-4'>AirMail <span
                    style={{
                        fontSize: "10px",
                        verticalAlign: "super",
                        position: "relative",
                        top: "-7px",
                        marginLeft: "-5px",
                        color: "#3b4249",
                        background: "none",
                        fontWeight: "400",
                    }}
                >
                    TM
                </span></h3>
                <Conversations onSelectChat={setSelectedChat} socket={socket} />
            </div>

            {/* Sidebar - Only Visible on Mobile (md and below) */}
            <div
                ref={drawerRef}
                className={`fixed top-[7.7rem] sm:top-[7.7rem] md:top-[10.7rem] inset-y-0 left-0 z-50 bg-white w-2/3 sm:w-1/2 border-r border-gray-300 
    transition-transform duration-300 transform ${isDrawerOpen ? 'translate-x-0' : '-translate-x-full'} lg:hidden`}
            >

                <div className="flex items-center justify-between p-4 bg-gray-100">
                    <h3 className="text-lg font-semibold">
                        AirMail <span className="text-xs text-gray-500 align-super">TM</span>
                    </h3>
                    {/* Close button only on mobile */}
                    <button
                        onClick={() => setIsDrawerOpen(false)}
                        className="text-lg font-bold text-gray-700"
                    >
                        ✖
                    </button>
                </div>
                <Conversations
                    onSelectChat={(chat) => {
                        setSelectedChat(chat);
                        setIsDrawerOpen(false); // Close drawer when chat is selected
                    }}
                    socket={socket}
                />
            </div>

            <div className="relative top-0 w-full bg-gray-100 lg:w-2/3 md:top-12 xl:top-0">
                {selectedChat ? (
                    <Messages chat={selectedChat} messages={messages} socket={socket} />
                ) : (
                    <div className="flex items-center justify-center h-full text-gray-500">
                        Select a conversation to view messages
                    </div>
                )}
            </div>
        </div>
    );
};